import React, { useState } from 'react';
import ShieldCheckIcon from '../ShieldCheckIcon';
import { toast } from '../Toast';
import SettingsModal from './SettingsModal';
import CardBrandLogo, { CardBrand, getCardBrand } from './CardBrand';

interface Props {
    holder: string;
    onClose: () => void;
    // preview: the page shows the new last four digits, nothing reaches a payment provider
    onSave: (card: { brand: CardBrand; last4: string; expiry: string; holder: string }) => void;
}

// "1234 5678 9012 3456" and "MM / YY" as the user types
const formatNumber = (v: string) => v.replace(/\D/g, '').slice(0, 16).replace(/(\d{4})(?=\d)/g, '$1 ');
const formatExpiry = (v: string) => {
    const d = v.replace(/\D/g, '').slice(0, 4);
    return d.length > 2 ? `${d.slice(0, 2)} / ${d.slice(2)}` : d;
};

const UpdateCardModal: React.FC<Props> = ({ holder, onClose, onSave }) => {
    const [name, setName] = useState(holder);
    const [number, setNumber] = useState('');
    const [expiry, setExpiry] = useState('');
    const [cvc, setCvc] = useState('');

    const digits = number.replace(/\D/g, '');
    const brand = getCardBrand(digits);
    const canSave = !!brand && name.trim().length > 0 && digits.length >= 15 && /^\d{2} \/ \d{2}$/.test(expiry) && cvc.length >= 3;

    const save = () => {
        if (!brand) return;
        onSave({ brand, last4: digits.slice(-4), expiry: `${expiry.slice(0, 2)}/20${expiry.slice(-2)}`, holder: name.trim() });
        toast.info('Preview only: this isn’t connected yet, so the card was not changed');
    };

    return <SettingsModal icon={<ShieldCheckIcon />} title="Update the Card on File" sub="Charged once a year on the renewal date" onClose={onClose}
        footerNote="Only the account owner can change the card."
        footer={<button type="button" className="btn-primary" onClick={save} disabled={!canSave}>Save Card</button>}>
        <label className="field">
            <span className="label">Name on card</span>
            <input value={name} onChange={e => setName(e.target.value)} autoComplete="cc-name" />
        </label>
        <label className="field">
            <span className="label">Card number</span>
            <span className="card-number">
                <input inputMode="numeric" value={number} onChange={e => setNumber(formatNumber(e.target.value))} placeholder="1234 5678 9012 3456" autoComplete="cc-number" autoFocus />
                {brand && <CardBrandLogo brand={brand} />}
            </span>
        </label>
        <div className="fields">
            <label className="field">
                <span className="label">Expiry</span>
                <input inputMode="numeric" value={expiry} onChange={e => setExpiry(formatExpiry(e.target.value))} placeholder="MM / YY" autoComplete="cc-exp" />
            </label>
            <label className="field">
                <span className="label">Security code</span>
                <input inputMode="numeric" value={cvc} onChange={e => setCvc(e.target.value.replace(/\D/g, '').slice(0, 4))} placeholder="CVC" autoComplete="cc-csc" />
            </label>
        </div>
        <div className="secure"><ShieldCheckIcon /> Card details go straight to our payment provider. Investi never sees or stores the full number.</div>
    </SettingsModal>;
};

export default UpdateCardModal;
